var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { RADIAN } from '../constants';
var rectangleHeight = 12;
var rectangleWidth = 3;
var GaugeChartLabelLine = /** @class */ (function (_super) {
    __extends(GaugeChartLabelLine, _super);
    function GaugeChartLabelLine(props) {
        var _this = _super.call(this, props) || this;
        _this.mouseOut = _this.mouseOut.bind(_this);
        _this.mouseOver = _this.mouseOver.bind(_this);
        return _this;
    }
    GaugeChartLabelLine.prototype.mouseOver = function (position, tickColor) {
        var _a = this.props.tooltip, color = _a.color, records = _a.records, percent = _a.percent, amount = _a.amount;
        this.props.setTooltip({ amount: amount, records: records, percent: percent, position: position, color: color || tickColor });
    };
    GaugeChartLabelLine.prototype.mouseOut = function () {
        this.props.setTooltip(null);
    };
    GaugeChartLabelLine.prototype.render = function () {
        var _this = this;
        var _a = this.props, cx = _a.cx, cy = _a.cy, outerRadius = _a.outerRadius, show = _a.show, startAngle = _a.startAngle, tickColor = _a.tickColor;
        if (!show) {
            return null;
        }
        var sx = cx + (outerRadius * Math.cos(-RADIAN * startAngle));
        var sy = cy + (outerRadius * Math.sin(-RADIAN * startAngle));
        var offset = outerRadius + rectangleHeight;
        var mx = cx + (offset * Math.cos(-RADIAN * (startAngle - rectangleWidth)));
        var my = cy + (offset * Math.sin(-RADIAN * (startAngle - rectangleWidth)));
        var zx = cx + (offset * Math.cos(-RADIAN * (startAngle + rectangleWidth)));
        var zy = cy + (offset * Math.sin(-RADIAN * (startAngle + rectangleWidth)));
        return (React.createElement("polygon", { onMouseOver: function () { return _this.mouseOver({ x: sx + 10, y: sy }, tickColor); }, onMouseOut: this.mouseOut, points: sx + "," + sy + " " + mx + "," + my + " " + zx + "," + zy, fill: tickColor }));
    };
    return GaugeChartLabelLine;
}(React.Component));
export default GaugeChartLabelLine;
//# sourceMappingURL=GaugeChartLabelLine.js.map